import { useIsUserHaveRole } from '../../../hooks/use-is-user-have-role';
import { USER_ROLES } from '../../../constants';
import { ColumnsVariant, ColumnType } from '../../table-component/table-component.props';
import React from 'react';
import DriverCell from '../list-view/driver-cell';
import LeasingRateCell from '../list-view/leasing-rate-cell';
import ImageCell from '../list-view/image-cell';
import StatusCell from '../list-view/status-cell';
import { TABLE_MENU_WIDTH } from '../../table-component/table-component';
import MenuCell from '../list-view/menu-cell';

const useListViewColumns = (reloadList: (deactivateCar?: boolean) => void) => {
  const isDriver = useIsUserHaveRole(USER_ROLES.driver.id);

  const columns: ColumnType[] = [
    {
      name: '',
      type: ColumnsVariant.Text,
      component: <ImageCell />,
      sort: false,
      width: '90px'
    },
    {
      name: 'Konfiguration',
      type: ColumnsVariant.Text,
      propName: 'uds_name',
      sort: true,
      sortName: 'createdon',
      width: '10%'
    },
    {
      name: 'Konfigurations-Typ',
      type: ColumnsVariant.Text,
      propName: 'globalFaConfigurationType',
      sort: false,
      width: '10%'
    },
    {
      name: 'Bezeichnung',
      type: ColumnsVariant.Text,
      propName: 'uds_title',
      sort: false,
      width: '10%'
    },
    {
      name: 'Fahrer',
      type: ColumnsVariant.Text,
      component: <DriverCell />,
      sort: false,
      width: '10%'
    },
    {
      name: 'Bruttolistenpreis',
      type: ColumnsVariant.Text,
      propName: 'uds_listenpreis',
      sort: false,
      width: '10%'
    },
    {
      name: 'Leasingrate',
      type: ColumnsVariant.Text,
      component: <LeasingRateCell />,
      sort: false,
      width: '10%'
    },
    {
      name: 'Status',
      type: ColumnsVariant.Chip,
      component: <StatusCell />,
      sort: false,
      width: '10%'
    },
    {
      name: 'Freigeber',
      type: ColumnsVariant.Text,
      propName: 'freigeber',
      sort: false,
      width: '10%'
    },
    {
      name: '',
      type: ColumnsVariant.Menu,
      sort: false,
      component: <MenuCell reloadList={reloadList} />,
      width: TABLE_MENU_WIDTH
    }
  ];

  return columns.filter(column => (isDriver ? column.name !== 'Fahrer' : true));
};
export default useListViewColumns;
